import { useOfferFiltersDispatch, useOfferFiltersState, } from "../context/OfferFiltersContext";
import { useFilterTracking } from "../hooks/useFilterTracking";
import { toStringArray } from "../utils/buildQueryString";
import React, { useState } from "react";
export default function CheckboxList({ filter, facet, }) {
    var _a, _b;
    const { selectedState } = useOfferFiltersState();
    const dispatch = useOfferFiltersDispatch();
    const { trackFilterChange } = useFilterTracking();
    const [search, setSearch] = useState("");
    const param = filter.id;
    const current = toStringArray(selectedState[param]);
    const facetItems = (_a = facet === null || facet === void 0 ? void 0 : facet.facet_data) !== null && _a !== void 0 ? _a : {};
    const list = Object.values(facetItems).filter((item) => !search || item.label.toLowerCase().includes(search.toLowerCase()));
    function handleToggle(value) {
        const arr = toStringArray(selectedState[param]);
        const next = arr.includes(value)
            ? arr.filter((v) => v !== value)
            : [...arr, value];
        trackFilterChange(filter, next);
        dispatch({
            type: "set_selected",
            payload: Object.assign(Object.assign({}, selectedState), { [param]: next.length ? next : undefined }),
        });
    }
    const hasSearch = (_b = filter.plugins) === null || _b === void 0 ? void 0 : _b.includes("search");
    return (<div className="space-y-3">
      {hasSearch && (<div className="relative mt-1">
          <input type="text" placeholder="Szukaj…" value={search} onChange={(e) => setSearch(e.target.value)} className="w-full py-3 bg-[#EBECEF] rounded-full border-none text-[#66676C] focus:ring-black pl-5 pr-7"/>
          <span className="absolute right-3 top-1/2 -translate-y-1/2">
            <svg className={"size-6"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M10.5 17C6.916 17 4 14.084 4 10.5C4 6.916 6.916 4 10.5 4C14.084 4 17 6.916 17 10.5C17 14.084 14.084 17 10.5 17ZM17.1685 15.7545C18.3115 14.3065 19 12.484 19 10.5C19 5.813 15.187 2 10.5 2C5.813 2 2 5.813 2 10.5C2 15.187 5.813 19 10.5 19C12.4835 19 14.3065 18.3115 15.754 17.1685L20.5855 22H22V20.586L17.1685 15.7545Z" fill="currentColor"/>
            </svg>
          </span>
        </div>)}
      <div>
        {list.map((item) => (<label key={item.value} className={`flex items-center gap-3 py-2 cursor-pointer ${item.disabled || !item.available
                ? "opacity-50 pointer-events-none"
                : ""}`}>
            <input type="checkbox" checked={current.includes(item.value)} onChange={() => handleToggle(item.value)} disabled={item.disabled || !item.available} className="rounded border-[#0C191D] size-[18px] rounded-[3px] text-black focus:ring-0 focus:ring-offset-0"/>
            <span className="text-gray-900">{item.label}</span>
          </label>))}
      </div>
    </div>);
}
